import React from 'react'
import { SignupContext, useSignupProvider } from './Signup.hooks'
import Alert from 'react-bootstrap/Alert'

import StepBilling from './StepBilling'
import StepAttendees from './StepAttendees'
import StepSummary from './StepSummary'
import Stepper from './Stepper'
import SuccessView from './SuccessView'

const Signup = ({ course }) => {
  const context = useSignupProvider({ course })

  const { error, loading, view, registrations, forWaitingList } = context

  if (error) {
    console.log(error)
    return (
      <Alert variant="danger">
        Bei deiner Anmeldung ist leider ein Fehler aufgetreten.
      </Alert>
    )
  }

  if (course.status === 'LOCKED') {
    return (
      <Alert variant="danger">
        Anmeldungen für diesen Kurs sind im Moment nicht möglich.
      </Alert>
    )
  }

  if (registrations) {
    return (
      <SignupContext.Provider value={context}>
        <SuccessView />
      </SignupContext.Provider>
    )
  }
  return (
    <SignupContext.Provider value={context}>
      {forWaitingList && (
        <Alert variant="info">
          Der Kurs ist derzeit vollständig belegt. Du meldest dich für die
          Warteliste an.
        </Alert>
      )}
      <Stepper className="mb-5" />
      {view === 'billing' && <StepBilling />}
      {view === 'attendees' && <StepAttendees />}
      {view === 'summary' && <StepSummary />}
    </SignupContext.Provider>
  )
}

export default Signup
